import styled from 'styled-components';

export const Column = styled.div`
  display: inline-block;
  margin-top: 5px;
  width: 100%;

  @media (min-width: 600px) {
    vertical-align: top;
    margin-right: 1%;
    max-width: ${props => ((100/props.width) - 1) + "%" };
  }
`;

export default Column;